<template>
  <main class="mx-auto max-w-6xl px-4 py-8 space-y-10 md:py-12">
    <slot />
  </main>
</template>
